import { Button } from './button';
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from './dialog';

export function ConfirmDialog({
	open,
	onOpenChange,
	title,
	description,
	confirmLabel = 'Delete',
	cancelLabel = 'Cancel',
	variant = 'destructive',
	loadingLabel,
	loading,
	onConfirm,
}: {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	title: string;
	description: string;
	confirmLabel?: string;
	cancelLabel?: string;
	/** `default` for confirming a non-destructive action, e.g. adding something. */
	variant?: 'destructive' | 'default';
	/** Shown on the confirm button while loading. Defaults to "Deleting…" for destructive. */
	loadingLabel?: string;
	loading?: boolean;
	onConfirm: () => void;
}) {
	const busyLabel =
		loadingLabel ?? (variant === 'destructive' ? 'Deleting…' : `${confirmLabel}…`);
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-sm">
				<DialogHeader className="p-4">
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription>{description}</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button
						variant="outline"
						onClick={() => onOpenChange(false)}
						disabled={loading}
					>
						{cancelLabel}
					</Button>
					<Button variant={variant} onClick={onConfirm} disabled={loading}>
						{loading ? busyLabel : confirmLabel}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
